/**
 * Centralized React Query key factory.
 *
 * Hierarchy lets you invalidate broadly:
 *   queryClient.invalidateQueries({ queryKey: ['media', slug] })
 *   → invalidates ALL media queries for that wedding (recent, topLiked, comments, etc.)
 */
export const queryKeys = {
  wedding: {
    rsvp:     (slug: string) => ['wedding', slug, 'rsvp']     as const,
    activity: (slug: string) => ['wedding', slug, 'activity'] as const,
  },
  media: {
    all:      (slug: string) => ['media', slug]                                        as const,
    recent:   (slug: string, kind: string) => ['media', slug, 'recent', kind]          as const,
    topLiked: (slug: string) => ['media', slug, 'top-liked']                           as const,
    comments: (slug: string, mediaId: string) => ['media', slug, 'comments', mediaId] as const,
    mine:     (slug: string) => ['media', slug, 'mine']                                as const,
  },
  albums: {
    list:  (slug: string) => ['albums', slug]                            as const,
    items: (slug: string, albumId: string) => ['albums', slug, albumId] as const,
  },
} as const;
